import {CompanySpaceApi, CompanySpacesCheckSubdomainAvailabilityPostRequest} from "../generated-api";
import {API_CONFIG} from "app/api-config";
import {createAsyncThunk} from "@reduxjs/toolkit";

const companySpaceApi = new CompanySpaceApi(API_CONFIG);

export const checkDomainAvailability = createAsyncThunk('companySpace/checkDomainAvailability', async (args: CompanySpacesCheckSubdomainAvailabilityPostRequest) => {
    return await companySpaceApi.companySpacesCheckSubdomainAvailabilityPost(args);
});
